import { useEffect, useState, useSyncExternalStore } from 'react';
import { api } from '@/lib/api';
import { createCourseLookup } from '@/lib/courseLookup';
import { useAuthStore } from '@/store/authStore';

function sessionKey() {
  const session = useAuthStore.getState();
  return `${session.sessionGeneration}:${session.userId ?? ''}`;
}

export function useCourseLookup<Selected>() {
  const [lookup] = useState(() => createCourseLookup<Selected>({ api, getSessionKey: sessionKey }));
  const state = useSyncExternalStore(lookup.subscribe, lookup.getSnapshot);
  useEffect(() => {
    const unsubscribe = useAuthStore.subscribe((current, previous) => {
      if (current.sessionGeneration !== previous.sessionGeneration || current.userId !== previous.userId) lookup.reset();
    });
    return () => { unsubscribe(); lookup.suspend(); };
  }, [lookup]);
  return { ...state, lookup };
}
